import {ApiClientService} from '@dofleini/security';
import {API_SETTINGS} from '../constants/api.settings';

class ForgotPassword {

  constructor() {
    this.service = ApiClientService;
  }

  init = (params) => {
    try {
      return this.service.post(`${API_SETTINGS.auth}/forgot-password/init`, params);
    } catch (error) {
      console.error(error);
    }
  };

  check = (params) => {
    try {
      return this.service.post(`${API_SETTINGS.auth}/forgot-password/check`, params);
    } catch (error) {
      console.error(error);
    }
  };

  finish = (params) => {
    try {
      return this.service.post(`${API_SETTINGS.auth}/forgot-password/finish`, params);
    } catch (error) {
      console.error(error);
    }
  }
}

export default new ForgotPassword();
